import { render, staticRenderFns } from "./PostPackageView.vue?vue&type=template&id=a88d758e&scoped=true"
import script from "./PostPackageView.vue?vue&type=script&lang=js"
export * from "./PostPackageView.vue?vue&type=script&lang=js"
import style0 from "./PostPackageView.vue?vue&type=style&index=0&id=a88d758e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88d758e",
  null
  
)

export default component.exports